import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_LOADING_SEND,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  EDIT_ITEM,
  DELETE_ITEM,
  SAVE_FOCUS_SUPPLIER_REQUEST,
  SET_LOADING_SELECTS,
  GET_LIST_FOCUS_SUPPLIER_REQUEST,
  GET_LIST_FOCUS_SUPPLIER_SUCCESS,
  SAVE_FOCUS_SUPPLIER_SUCCESS,
  GET_SELECTS_SUCCESS
} from './focus-supplier-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const getAllFocusSupplierRequest = () => {
  return {
    type: GET_LIST_FOCUS_SUPPLIER_REQUEST
  };
};

export const getAllFocusSupplierSuccess = payload => {
  return {
    type: GET_LIST_FOCUS_SUPPLIER_SUCCESS,
    payload
  };
};

export const editItem = (id: string) => {
  return {
    type: EDIT_ITEM,
    id
  };
};

export const deleteItem = (id: string) => {
  return {
    type: DELETE_ITEM,
    id
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveFocusSupplierRequest = (payload: any, id?: string) => {
  return {
    type: SAVE_FOCUS_SUPPLIER_REQUEST,
    payload,
    id
  };
};

export const saveFocusSupplierSuccess = (payload: any) => {
  return {
    type: SAVE_FOCUS_SUPPLIER_SUCCESS,
    payload
  };
};

export const getSelectsSuccess = (payload: any) => {
  return {
    type: GET_SELECTS_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};
